// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from "vuex";
import VueI18n from "vue-i18n";
import vuetify from '@/plugins/vuetify' // path to vuetify expo
import $ from "jquery";

import config from '@/config/index.js'
import tools from '../static/js/tools.js'
import { pinyinUtil }  from '../static/js/pinyin-withtone.js'

// 缓存
import { store } from "@/store/store";
// JS初始化数据
import init from '@/store/init.js';

Vue.prototype.$config = config
Vue.prototype.$tools = tools
Vue.prototype.$pinyin = pinyinUtil
Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(init);


function getLanguage() {
  // 将选择的语言存在localStorage中
  let locale = localStorage.getItem("profile-locale");
  if (locale) {
    return locale;
  } else {
    return "zh-CN";
  }
}

const language = getLanguage();
Vue.locale = () => {};
const i18n = new VueI18n({
  locale: language,
  messages: {
    "zh-CN": require("@/assets/language/zh-CN.json"),
    "zh-HK": require("@/assets/language/zh-HK.json"),
    "en-US": require("@/assets/language/en-US.json")
    
  }
});

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  vuetify,
  created: function() {
    this.init()
  },
  components: { App },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js